// extracted by mini-css-extract-plugin
module.exports = {"input_wrapper":"input_wrapper__3lwpnaFri8TfA","search":"search__asAnKdMMYhRUD","product":"product__0YdCh7KhUd3Ob","delete":"delete__XeiAjWzx4zW5y"};